module.exports = __webpack_public_path__ + "static/media/nullcon.a6424bb9.jpg";